import React, { useState, useEffect } from "react";
import { useForm, FormProvider } from "react-hook-form";
import { laboratoryService } from "../../services/laboratory.services";
import { ComplementAreaSection } from "./ComplementAreaSection";
import { PopUp } from "../PopUps/PopUp";
import "../../assets/css/complement.css";

export const ComplementSettings = () => {
  const [laboratoryAreas, setLaboratoryAreas] = useState([]);
  const [parametersByArea, setParametersByArea] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState({ error: false });
  const [saving, setSaving] = useState(false);

  const methods = useForm({
    defaultValues: {
      parameters: {},
    },
  });

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      setLoading(true);

      // Načítanie laboratórnych oblastí
      const areasResponse = await laboratoryService.getLaboratoryAreas();
      const areas = areasResponse.results || [];
      setLaboratoryAreas(areas);

      // Načítanie všetkých parametrov
      const parametersResponse =
        await laboratoryService.getParameterDefinitions();
      const allParameters = parametersResponse.results || [];

      // Zoskupenie parametrov podľa oblastí
      const groupedParameters = {};
      const formData = {};

      areas.forEach((area) => {
        const areaParameters = allParameters.filter(
          (param) => param.area === area.id,
        );
        groupedParameters[area.id] = areaParameters;

        // Nastavenie defaultných hodnôt pre formulár
        areaParameters.forEach((param) => {
          formData[param.id] = {
            lower_limit: param.lower_limit || "",
            upper_limit: param.upper_limit || "",
            units: param.units || "",
            is_plasma_concentration: param.is_plasma_concentration || false,
          };
        });
      });

      setParametersByArea(groupedParameters);
      methods.reset({ parameters: formData });
    } catch (error) {
      console.error("Error loading complement data:", error);
      setError({
        error: true,
        message: "Chyba při načítání dat komplementu",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleParameterChange = async (
    parameterId,
    parameterData,
    shouldSave = false,
  ) => {
    if (shouldSave) {
      try {
        setSaving(true);
        const formValues = methods.getValues();
        const parameterFormData = formValues.parameters[parameterId];

        const updateData = {
          lower_limit: parameterFormData.lower_limit,
          upper_limit: parameterFormData.upper_limit,
          units: parameterFormData.units,
          is_plasma_concentration: parameterFormData.is_plasma_concentration,
        };

        await laboratoryService.updateParameterDefinition(
          parameterId,
          updateData,
        );

        // Refresh data after successful save
        await loadData();
      } catch (error) {
        console.error("Error saving parameter:", error);
        setError({
          error: true,
          message: "Chyba při ukládání parametru",
        });
      } finally {
        setSaving(false);
      }
    }
  };

  const togglePopup = () => {
    setError({ error: false });
  };

  if (loading) {
    return (
      <div className="complement-container">
        <div className="complement-content">
          <div className="complement-loading">
            Načítání referenčních mezí laboratórních výsledků...
          </div>
        </div>
      </div>
    );
  }

  return (
    <FormProvider {...methods}>
      <div className="complement-container">
        <div className="complement-content">
          {error.error && (
            <PopUp toggle={togglePopup} message={error.message} />
          )}

          <div>
            <h2 className="complement-title">
              Nastavení referenčních mezí laboratórních výsledků
            </h2>
            {/* <p className="complement-subtitle">
              Aktivní nastavení dělí komplementy
            </p> */}
          </div>

          {saving && <div className="complement-saving">Ukládání...</div>}

          {laboratoryAreas.map((area) => (
            <ComplementAreaSection
              key={area.id}
              area={area}
              parameters={parametersByArea[area.id] || []}
              onParameterChange={handleParameterChange}
              errors={methods.formState.errors}
            />
          ))}
        </div>
      </div>
    </FormProvider>
  );
};
